import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08249f7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "initial-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filler" }, null, -1))

import PhoneVerificationForm from "@/components/forms/PhoneVerificationForm/PhoneVerificationForm.vue";
import ReportErrorIconButton from "@/components/buttons/ReportErrorIconButton/ReportErrorIconButton.vue";
import MobileNavigationBar from "@/components/layouts/MobileNavigationBar/MobileNavigationBar.vue";
import { MobileNavigationBarIconType } from "@/types/app";
import { getRefreshTokenFromPhoneAsync } from "@/services/maitrejaApi/auth";
import { ActionTypes, MutationTypes } from "@/store";
import { ConnectPhoneHandler } from "@/types/auth";
import { handleOnboardingRedirect } from "@/utils/settings";
import { useStore } from "vuex";
import { useGetConnectPhoneProperties } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPhone',
  setup(__props) {

const { commit, dispatch } = useStore();
const handleSubmit: ConnectPhoneHandler = async (data, idToken) => {
  commit(MutationTypes.SET_IS_LOADING, true);
  try {
    await getRefreshTokenFromPhoneAsync(
      idToken,
      data.countryCode,
      data.phoneNumber.replaceAll(" ", ""),
    );
    await dispatch(ActionTypes.LOGIN_AUTH);
    handleOnboardingRedirect();
  } catch (err) {
    throw err;
  }
};

const { handleRedirectBack, handleTogglePopup, ...otherProps } =
  useGetConnectPhoneProperties(handleSubmit);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!otherProps.data.isPopupOpen)
      ? (_openBlock(), _createBlock(ReportErrorIconButton, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(MobileNavigationBar, {
      "icon-type": _unref(MobileNavigationBarIconType).Circle,
      "handle-redirect": _unref(handleRedirectBack)
    }, null, 8, ["icon-type", "handle-redirect"]),
    _createVNode(PhoneVerificationForm, _mergeProps(otherProps, { onTogglePopup: _unref(handleTogglePopup) }), null, 16, ["onTogglePopup"]),
    _hoisted_2
  ]))
}
}

})